import { useContext } from 'react'
import { PaywallContext } from './PaywallContext'

export const usePaywall = () => {
  const context = useContext(PaywallContext)

  if (!context) {
    throw new Error('usePaywall must be used within a PaywallProvider')
  }

  return context
}
